// @ts-nocheck
import Vue from 'vue';
import SuiVue from 'semantic-ui-vue';
import VueNumerals from 'vue-numerals';
import Paginate from 'vuejs-paginate';
import VueMoment from 'vue-moment';
import VueNumberInput from '@chenfengyuan/vue-number-input';
import infiniteScroll from 'vue-infinite-scroll';
import VueStripeMenu from 'vue-stripe-menu';
import Vuelidate from 'vuelidate';
import VueSplash from 'vue-splash';

import moment from 'moment';

require('moment/locale/es');

import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(SuiVue);
Vue.use(VueNumerals);
Vue.component('paginate', Paginate);
Vue.use(VueNumberInput);
Vue.use(VueMoment, { moment });
Vue.use(infiniteScroll);

Vue.use(VueStripeMenu);
Vue.use(Vuelidate);
Vue.use(VueSplash);

new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app');
